import {ComponentProps, useEffect, useState} from "react";
import {RouteComponentProps, useParams} from "react-router";
import {useRequest} from "ahooks";
import * as api from "../../apis/salesOrder";
import * as commonApi from "../../apis/common";
import styles from "./index.module.css";
import {Descriptions, Table} from "antd";
import dayjs from "dayjs";
import {useDispatch, useSelector} from "react-redux";
import {Dispatch, RootState} from "../../models";
import {SalesOrderStatusMapping, SalesOrderStatusOptions} from "../../utils/constants";
import {ColumnProps} from "antd/lib/table";
import {PageLoading} from "@ant-design/pro-components";



type RouteParams = {
    id: string
}

function SalesOrderPrint(props: RouteComponentProps<RouteParams>) {

    const id = useParams<RouteParams>().id;
    const userToken = useSelector((state: RootState) => state.auth.userToken)
    const userInfo = useSelector<RootState, RootState['auth']>(state => state.auth)?.user;
    const [order, setOrder] = useState<any>({});
    const dict = useSelector<RootState, RootState['dict']>(state => state.dict);
    const baseData = useSelector<RootState, RootState['baseData']>(state => state.baseData);
    const dispatch = useDispatch<Dispatch>();
    const authDispatch = dispatch.auth;
    const baseDataDispatch = dispatch.baseData;
    const dictDispatch = dispatch.dict;
    const [provinceCode, setProvinceCode] = useState<any>();
    const [cityCode, setCityCode] = useState<any>();

    const {loading: loadingGetOrder, run: runGetOrder} = useRequest(api.getSalesOrderDetail, {
        manual: true,
        onSuccess(res) {
            const result = res.data.data;
            setProvinceCode(result.province);
            setCityCode(result.city);
            setOrder(result);
        }
    });
    const {loading: loadingProvince, run: runProvince} = useRequest(commonApi.getAreaOption,{
        manual: true,
        onSuccess(res){
            const provinceName = res.data.data.find((a:any)=>a.areaCode==provinceCode)?.areaName;
            setOrder({...order, provinceName});
        }
    });
    const {loading:loadingCity, run: runCity} = useRequest(commonApi.getAreaOption, {
        manual: true,
        onSuccess(res){
            const cityName = res.data.data.find((a:any)=>a.areaCode==cityCode)?.areaName;
            setOrder({...order, cityName});
        }
    })

    useEffect(() => {
        if (userToken) {
            authDispatch.getUserInfo().then(() => {
                baseDataDispatch.getBaseData()
                dictDispatch.getAllDict()
                runGetOrder(id)
            });
        }
    }, [userToken, authDispatch]);
    useEffect(()=>{
        if(!!provinceCode){
            runProvince(1)
        }
    },[provinceCode]);
    useEffect(()=>{
        if(!!cityCode && !!provinceCode){
            runCity(2,provinceCode)
        }
    },[provinceCode,cityCode]);

    const getExpressName = ()=>{
        if(!order.expressId) return null;
        return baseData?.expresses?.find((e:any)=>e.key==order.expressId)?.value;
    }

    const BaseDataTitle = (
        <div className={styles.BaseTitle}>
            <span>销售公司：&nbsp;{userInfo?.currentCompany?.name}</span>
            <span className={styles.PrintBtn}><a onClick={()=>window.print()}>点击打印</a></span>
            <span>打印时间：&nbsp;{dayjs().format('lll')}</span>
        </div>
    );

    const columns:Array<ColumnProps<any>> = [
        {
            dataIndex: 'lineNumber',
            key: 'lineNumber',
            title: '序号',
        },
        {
            dataIndex: 'productCode',
            key: 'productCode',
            title: '商品编码'
        },
        {
            dataIndex: 'productName',
            key: 'productName',
            title: '商品名称'
        },
        {
            dataIndex: 'specification',
            key: 'specification',
            title: '规格'
        },
        {
            dataIndex: 'unit',
            key: 'unit',
            title: '单位'
        },
        {
            dataIndex: 'price',
            key: 'price',
            title: '单价'
        },
        {
            dataIndex: 'qty',
            key: 'qty',
            title: '数量'
        },
        {
            dataIndex: 'amount',
            key: 'amount',
            title: '小计'
        },
        {
            dataIndex: 'expirationDate',
            key: 'expirationDate',
            title: '效期'
        },
        {
            dataIndex: 'enableGiveaway',
            key: 'enableGiveaway',
            title: '赠品',
            render(v){
                if(v==true){
                    return '是'
                }else{
                    return '否'
                }
            }
        }
    ];

    return <div className={styles.Page}>
        {loadingGetOrder?<PageLoading/>:
            <>
                <Descriptions size={'small'} className={styles.Base} title={BaseDataTitle} bordered column={3}>
                    <Descriptions.Item key={'订单号'} label={'订单号'}>{order.code}</Descriptions.Item>
                    <Descriptions.Item key={'订单日期'} label={'订单日期'}>{order.orderDate && dayjs(order.orderDate).format('ll')}</Descriptions.Item>
                    <Descriptions.Item key={'客户'} label={'客户'}>{order.dealerName}</Descriptions.Item>
                    <Descriptions.Item key={'终端医院全称'} label={'终端医院全称'}>{order.hospitalFullName}</Descriptions.Item>
                    <Descriptions.Item key={'销售人员'} label={'销售人员'}>{order.salesManName}</Descriptions.Item>
                    <Descriptions.Item key={'商务人员'} label={'商务人员'}>{order.businessManName}</Descriptions.Item>
                    <Descriptions.Item key={'运输方式'} label={'运输方式'}>{getExpressName()}</Descriptions.Item>
                    <Descriptions.Item key={'付款形式'} label={'付款形式'}>{dict?.['PaymentForm']?.[order.paymentForm]}</Descriptions.Item>
                    <Descriptions.Item key={'账期'} label={'账期'}>{order.period}</Descriptions.Item>
                    <Descriptions.Item key={'币种'} label={'币种'}>{order.currencyName}</Descriptions.Item>
                    <Descriptions.Item key={'收货地址'} label={'收货地址'} span={2}>{order.provinceName}{order.cityName}{order.detailAddress}</Descriptions.Item>
                    <Descriptions.Item key={'收货人'} label={'收货人'}>{order.receiver}</Descriptions.Item>
                    <Descriptions.Item key={'收货人电话'} label={'收货人电话'}>{order.receiverPhone}</Descriptions.Item>
                    <Descriptions.Item key={'发票类型'} label={'发票类型'}>{dict?.['InvoiceType']?.[order.invoiceType]}</Descriptions.Item>
                    <Descriptions.Item key={'发票税号'} label={'发票税号'}>{order.taxNo}</Descriptions.Item>
                    <Descriptions.Item key={'发票详细地址'} label={'发票详细地址'} span={2}>{order.invoiceAddress}</Descriptions.Item>
                    <Descriptions.Item key={'发票号'} label={'发票号'}>{order.invoices}</Descriptions.Item>
                    <Descriptions.Item key={'开票日期'} label={'开票日期'}>{order.invoiceDate&& dayjs(order.invoiceDate).format('ll')}</Descriptions.Item>
                    <Descriptions.Item key={'订单状态'} label={'订单状态'}>{SalesOrderStatusMapping[order.status]}</Descriptions.Item>
                    <Descriptions.Item key={'备注'} label={'备注'} span={2}>{order.remark}</Descriptions.Item>
                    <Descriptions.Item key={'订单返利'} label={'订单返利'}>{order.rebates}</Descriptions.Item>
                </Descriptions>
                <br/>
                <div className={styles.TableTitle}>
                    商品明细
                </div>
                <Table dataSource={order.item || []} columns={columns} pagination={false} loading={loadingGetOrder}/>

                <Descriptions title={'金额'} className={styles.Summary} bordered>
                    <Descriptions.Item span={1} label={'商品总额'}>{order.productTotalAmount}</Descriptions.Item>
                    <Descriptions.Item span={1} label={'运费'}>{order.shippingCost ?? order.expectShippingCost}</Descriptions.Item>
                    <Descriptions.Item span={1} label={'订单合计'}>{order.shippingCost + order.productTotalAmount}</Descriptions.Item>
                </Descriptions>
            </>}
    </div>;
}

export default SalesOrderPrint;